module.exports = __webpack_public_path__ + "media/images/icon-tiktok-b7140ec43bd7ef1cd807d9f9662905a9.svg";